import { Wrench } from 'lucide-react';
import { BaseHeader, Button } from '../../ui';
import { corelCommunication } from '../../../lib/corel/communication';
import { logger } from '../../../lib/terminalLogger';

interface ToolsHeaderProps {
  onShowShortcuts: () => void;
}

export function ToolsHeader({ onShowShortcuts }: ToolsHeaderProps) {
  const handleClearPasteLayer = async () => {
    try {
      logger.debug('Limpando camada de colagem (clear-paste-layer)');
      
      const result = await new Promise<any>((resolve) => {
        const id = corelCommunication.sendActionGuarded('clear-paste-layer', {
          targetLayer: '_PASTE_AT_MOUSE'
        }, (resp: any) => {
          resolve(resp);
        });
        if (!id) {
          resolve({ status: 'error', message: 'Sessão indisponível' });
        }
      });

      if (result.status === 'ok') {
        const message = result.message || 'Camada de colagem limpa com sucesso.';
        logger.info('Camada de colagem limpa:', message);
        // Opcional: mostrar notificação
      } else {
        const errorMessage = result.message || 'Erro ao limpar camada de colagem.';
        logger.error('Erro ao limpar camada de colagem:', errorMessage);
        alert(errorMessage);
      }
    } catch (error) {
      logger.error('Erro ao limpar camada de colagem:', error);
      alert('Erro ao limpar camada de colagem. Verifique se há um documento ativo.');
    }
  };

  return (
    <BaseHeader
      title="Ferramentas"
      icon={Wrench}
      actions={
        <>
          {/* Botão "Limpar Colados" - Oculto visualmente, mantida a lógica */}
          <Button
            variant="ghost"
            size="xs"
            onClick={handleClearPasteLayer}
            title="Limpar objetos colados"
            className="hidden hover:text-gray-300 mr-2 opacity-40 cursor-not-allowed pointer-events-none"
            disabled={true}
          >
            Limpar Colados
          </Button>
          {/* Botão "Mais opções" - Oculto visualmente, mantida a lógica */}
          <Button
            variant="ghost"
            size="xs"
            onClick={onShowShortcuts}
            title="Mais opções"
            className="hidden hover:text-gray-300 opacity-40 cursor-not-allowed pointer-events-none"
            disabled={true}
          >
            Mais opções
          </Button>
        </>
      }
      className="bg-navy-900 border-b border-navy-800"
    />
  );
}
